export default __webpack_public_path__ + "static/media/SAS Alert Tone 17.d7fa9b7e.mp3";